import * as msal from "@azure/msal-browser";
import { router } from "../../router";
import axios from "axios";
import store from "../store";

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AUTH_APPLICATION_ID,
    authority: `https://login.microsoftonline.com/${process.env.VUE_APP_AUTH_TENANT_ID}`,
    postLogoutRedirectUri: process.env.VUE_APP_LOGIN_URL,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

const loginRequest = {
  // This is the scope/permission that we need to request to be able to access the endpoints
  scopes: [`api://${process.env.VUE_APP_AUTH_APPLICATION_ID}/Mavday.API`]
};

const myMSALObj = new msal.PublicClientApplication(msalConfig);

export const auth = {
  namespaced: true,
  state: {
    user: {
      name: null,
      username: localStorage.getItem("username"),
    },
    loginHint: localStorage.getItem("loginHint"),
    homeAccountId: localStorage.getItem("homeAccountId"), // for retrieving AccountInfo
    signingIn: false,
    signInFailed: false,
    signInError: null,
    // sessionToken: localStorage.getItem("sessionToken"),
    sessionToken: null,
    managingSessions: false,
  },
  getters: {
    getLoginHint: (state) => {
      return state.loginHint;
    },
    getHomeAccountId: (state) => {
      return state.homeAccountId;
    },
    isSigningIn: (state) => {
      return state.signingIn;
    },
    isSignedIn: (state) => {
      //Our first check on the status of sign in depends if a sessionToken is present
      return state.sessionToken != null;
    },
    isSignedInFailed: (state) => {
      return state.signInFailed;
    },
    signInError: (state) => {
      return state.signInError;
    },
    getUUID: (state) => {
      return state.sessionToken;
    },
    getSessionToken: (state) => {
      return state.sessionToken;
    },
    isManagingSessions: (state) => {
      return state.managingSessions;
    }
  },
  mutations: {
    // store the session id
    signInSuccess(state, loginResponse) {
      state.signingIn = false;
      localStorage.setItem('loginHint', loginResponse.idTokenClaims.preferred_username); // also store loginHint in local storage
      localStorage.setItem('homeAccountId', loginResponse.account.homeAccountId); // also store homeId in local storage
      state.loginHint = loginResponse.idTokenClaims.preferred_username;
      state.homeAccountId = loginResponse.account.homeAccountId;
      state.user.name = loginResponse.idTokenClaims.name;
      state.user.username = loginResponse.account.username;
      state.signInFailed = false;

      // if(loginResponse.sessionToken) {
      // localStorage.setItem('sessionToken', loginResponse.sessionToken);
      state.sessionToken = loginResponse.sessionToken;
      state.managingSessions = false;
      // }
    },
    // clear session id
    signInFailed(state, error) {
      state.signingIn = false;
      state.loginHint = null;
      state.homeAccountId = null;
      state.user.name = null;
      state.user.username = null;
      state.signInFailed = true;
      state.signInError = error;
      state.sessionToken = null;
      state.managingSessions = false;
      localStorage.clear();
    },
    signOut(state) {
      state.signingIn = false;
      state.loginHint = null;
      state.homeAccountId = null;
      state.user.name = null;
      state.user.username = null;
      state.signInFailed = false;
      state.signInError = null;
      state.sessionToken = null;
      state.managingSessions = false;
      localStorage.clear();
    },
    signingIn(state) {
      state.signingIn = true;
    },
    managingSessions(state, value) {
      state.managingSessions = value;
    }
  },
  actions: {
    signInPopup({ getters, dispatch, commit }) {
      if (getters.isSigningIn) {
        console.log("[signInPopup] Sign-in is already in progress. Skipping sign-in popup.");
        return Promise.resolve("Sign-in is already in progress. Skipping sign-in popup.")
      }
      commit("signingIn");
      return myMSALObj.loginPopup(loginRequest)
        .then(async (loginResponse) => {
          console.log("[auth.store.signInPopup] signInPopup successful", loginResponse);

          const result = await dispatch('saveSession', {loginResponse});
          if(result) {
            return result;
          }
          else {
            throw new Error("Saving the session in database failed. Token might not be valid.")
          }
        })
        .catch(error => {
          console.log("[auth.store.signInPopup] signInPopup error: ", error);
          if (error == "BrowserAuthError: user_cancelled: User cancelled the flow.") {
            commit("signInFailed", "Login attempt cancelled.");
          } else {
            commit("signInFailed", "Invalid login.");
          }
          //Let the caller handle the catch condition so we only have one routing direction happening
          throw error;
        });
    },
    // silently check with Azure AD if a session is active (no popup or redirect)
    async silentSignIn({ getters, dispatch, commit }) {
      if (getters.isSigningIn) {
        console.log("[silentSignIn] Sign-in is already in progress. Skipping silent sign-in.");

        //This should be handled by the catch below
        throw new Error("Sign-in is already in progress. Skipping silent sign-in.");
      }
      commit("signingIn");
      console.log("[auth-store.silentSignIn] Performing silent sign-in");
      return await myMSALObj.acquireTokenSilent({
        scopes: loginRequest.scopes,
        account: myMSALObj.getAccountByHomeId(getters.getHomeAccountId)
      })
        .then(async (loginResponse) => {
          console.log("[auth.store.silentSignIn] Silent sign-in successful", loginResponse);
          const result = await dispatch('saveSession', {loginResponse});
          if(result) {
            return result;
          }
          else {
            throw new Error("Saving the session in database failed. Token might not be valid.")
          }
        })
        .catch(error => {
          console.log("Silent sign-in failed. Redirecting to /sso-login:", error);
          commit("signInFailed", "Login session expired.");

          //Let the caller handle the catch condition so we only have one routing direction happening
          throw error;

          //router.push("/sso-login");

          // // fallback to interaction when silent call fails
          // return myMSALObj.acquireTokenPopup({ account: myMSALObj.getAccountByHomeId(getters.getHomeAccountId) })
          //   .then(loginResponse => {
          //     console.log("AcquireTokenPopup successful");
          //     commit("signInSuccess", loginResponse);
          //     router.push("/batch-history");
          //     return loginResponse;
          //   }).catch(error => {
          //     console.log("AcquireTokenPopup failed:", error);
          //     commit("signInFailed");
          //     // throw error and let the caller push the route
          //     throw error;
          //   });
        });
    },

    // Called after the AD login (either method) succeeds.
    // Validates the AD JWT token in the endpoint and returns a new session token in the response (which is saved in db)
    async saveSession({commit, rootState, dispatch}, payload) {

      commit('managingSessions', true);

      const config = {
        headers: {
          Authorization: `Bearer ${payload.loginResponse.accessToken}` ,
        },
      };

      return axios.post(
        `${rootState.apiUrl}/saveSession`,
        {},
        config
      )
        .then((rslt) => {
          //Save the login details + sessionToken
          const loginAndSessionDetails = {
            sessionToken: rslt.data.sessionToken,
            ...payload.loginResponse,
          };
          commit(
            "signInSuccess",
            loginAndSessionDetails
          );
          dispatch('refreshCountdown');
          return loginAndSessionDetails;
        })
        .catch((err) => {
          console.log(`Saving session failed: ${err}`);
          return false;
        });
    },

    // Called whenever a new session token has been refreshed
    updateSessionToken({ dispatch, state }, payload) {
      console.log(`Saving new session token: ${payload.newSessionToken}`);
      state.sessionToken = payload.newSessionToken;
      dispatch('refreshCountdown');
    },

    signOut({ commit, getters }) {
      console.log("Signing out...")
      const account = myMSALObj.getAccountByHomeId(getters.getHomeAccountId);
      commit("signOut");
      myMSALObj.logout({ account: account });
    },
    getLoginInProgress() {
      return myMSALObj.interactionInProgress();
    },

    // For every 10 minutes, try to refresh the session token using the refresh endpoint.
    // The session token's validity is 15 minutes, so this will preempt this.
    refreshCountdown({commit, dispatch, rootState}) {

      const intervalId = setInterval(() => {

        console.log(`[refreshCountdown] Trying refresh token procedure... ${rootState.apiUrl}/refresh`);
        axios.post(
          `${rootState.apiUrl}/refresh`,
          {},
          {
            withCredentials: true //important for the refresh cookie to be sent
          }
        ).then((rslt)=>{
          clearInterval(intervalId);
          console.log(`Refresh succeeded: + ${JSON.stringify(rslt)}`);
          dispatch("updateSessionToken", {newSessionToken: rslt.data.sessionToken});

        }).catch(err => {
          clearInterval(intervalId);
          commit('signInFailed', "Session expired.");
          router.push("/sso-login");
          console.log(`[refreshCountdown] Refresh failed: + ${err}`);
          return false;
        });

      }, 600000); //10 Minutes

    }
  },
};